module.exports = __webpack_public_path__ + "img/上海交大LOGO.c86922bc.png";